// Initialize wishlist components when swat is ready
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push((swat) => {
  // Initialize any existing wishlist buttons
  document.querySelectorAll('swymcs-wishlist-button').forEach((component) => {
    component.initialize(swat);
  });
});

window.addEventListener('product:change', (e) => {
  const product = e.detail.product;
  const selectedVariant = e.detail.selectedVariant;
  window.CurrentProduct = product;

  window.SwymPageData = {
    ...window.SwymPageData,
    et: 1,
    empi: product.id,
    epi: selectedVariant?.id,
    dt: product.title,
    du: `https://${window.location.host + window.Shopify.routes.root}products/${product.handle}`,
    ct: product.type,
    pr: selectedVariant ? selectedVariant.price / 100 : undefined,
    iu: product.images[0],
    variants: selectedVariant ? [{ [selectedVariant.title]: selectedVariant.id }] : [],
    stk: selectedVariant?.inventory_quantity,
    op: selectedVariant?.compare_at_price ? selectedVariant.compare_at_price / 100 : undefined,
    uri: window.location.href,
    available: product.available,
    oosvariants: product.variants.filter((variant) => !variant.available).map((variant) => variant.id),
    vi: selectedVariant?.option1,
  };

  window.SwymProductInfo = {
    currentVariant: selectedVariant ? parseInt(selectedVariant.id) : undefined,
    product,
    variants: product.variants,
  };

  window.SwymProductVariants = {};

  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    window.SwymProductVariants[variant.id] = {
      ct: product.type,
      dt: product.title,
      du: `https://${window.location.host + window.Shopify.routes.root}products/${product.handle}`,
      empi: product.id,
      epi: variant.id,
      iu: product.images[0],
      pr: variant ? variant.price / 100 : undefined,
      stk: variant.inventory_quantity,
      variants: [{ [variant.title]: variant.id }],
      vi: variant.option1,
    }
  }
});

window.addEventListener('variant:change', (e) => {
  window.SwymPageData = {
    ...window.SwymPageData,
    ...window.SwymProductVariants[e.detail.variantId]
  }

  window.SwymProductInfo = {
    ...window.SwymProductInfo,
    currentVariant: parseInt(e.detail.variantId),
  };
});

if (!customElements.get('swymcs-wishlist-button')) {
  class SwymWishlistButton extends HTMLElement {
    constructor() {
      super();
      if (!window.wishlistItemVariantIds) {
        window.wishlistItemVariantIds = [];
      }
    }

    initialize(swat) {
      this.swat = swat;
      this.elements = {
        wishlistButton: this.querySelector('button'),
        unfilledState: this.querySelector('#swymUnfilled'),
        filledState: this.querySelector('#swymFilled'),
      };

      if (!this.elements.wishlistButton) return;

      this.elements.wishlistButton.classList.add('swym-loaded');
      const url = new URL(window.location.href);
      const variantId = url.searchParams.get('variant');

      if (!this.elements.wishlistButton.dataset.variantId && variantId) {
        this.elements.wishlistButton.dataset.variantId = variantId;
      }

      this.updateState({
        productId: this.elements.wishlistButton.dataset.productId,
        variantId: this.elements.wishlistButton.dataset.variantId,
      });

      // Add event listeners
      this.setupEventListeners();
    }

    updateState({ productId, variantId }) {
      this.productId = productId;
      this.variantId = variantId;

      this.fetchAndUpdateWishlistState();
    }

    fetchAndUpdateWishlistState() {
      this.swat.fetch((products) => {
        const isInWishlist = products.find((product) => product.empi == this.productId && product.epi == this.variantId);

        if (isInWishlist) {
          if (!window.wishlistItemVariantIds.includes(this.variantId)) {
            window.wishlistItemVariantIds.push(this.variantId);
          }
          this.elements.wishlistButton.classList.add('swym-added');
        } else {
          this.elements.wishlistButton.classList.remove('swym-added');
        }
      });
    }

    setupEventListeners() {
      // Add variant change listener for this instance
      window.addEventListener('variant:change', this.handleVariantChange.bind(this));

      // Add click event listener to this instance
      this.elements.wishlistButton.addEventListener('click', this.handleClick.bind(this));
      document.getElementById('size-dropdown-button')?.addEventListener('click', () => {
        document.getElementById('wishes-validation-messages').innerHTML = '';
      });
    }

    handleVariantChange(e) {
      const { productId, variantId } = e.detail;

      if (this.productId == productId) {
        this.updateState({ productId, variantId });
        this.elements.wishlistButton.dataset.productId = productId;
        this.elements.wishlistButton.dataset.variantId = variantId;
        document.getElementById('wishes-validation-messages').innerHTML = '';
      }
    }

    handleClick(e) {
      if (!window.SwymPageData) return;

      if (this.elements.wishlistButton.classList.contains('swym-added')) {
        this.removeFromWishlist();
      } else {
        this.addToWishlist();
      }

      this.updateCount();
    }

    removeFromWishlist() {
      this.swat.api.removeFromWishList(window.SwymPageData, (swat) => {
        let successMessage = window.pdpStrings.wishlist.removeFromWishlist
          .replace('__PRODUCT_TITLE__', window.SwymPageData.dt)
          .replace('__VARIANT_TITLE__', window.SwymPageData.vi);
        this.swat.ui.showSuccessNotification({ message: successMessage });
      });
      this.elements.wishlistButton.classList.remove('swym-added');
    }

    addToWishlist() {
      window.SwymPageData.et = 4; // wishlist event type

      if (!this.variantId) {
        document.getElementById('wishes-validation-messages').innerHTML = `
          <p class="text-[#ae0200]">${window.pdpStrings.wishlist.selectASize}</p>
        `;
        setTimeout(() => {
          document.getElementById('wishes-validation-messages').innerHTML = '';
        }, 3000)
        return;
      }

      window.SwymPageData.epi = parseInt(this.variantId);
      this.swat.addToWishList(window.SwymPageData, (e) => {
        if (!window.wishlistItemVariantIds.includes(window.SwymPageData.epi)) {
          window.wishlistItemVariantIds.push(window.SwymPageData.epi);
        }
        this.elements.wishlistButton.classList.add('swym-added');
        this.swat.ui.showSuccessNotification({
          message: window.pdpStrings.wishlist.addedToWishlist
            .replace('__PRODUCT_TITLE__', window.SwymPageData.dt)
            .replace('__VARIANT_TITLE__', window.SwymPageData.vi),
        });
      });
    }

    updateCount() {
      var countHTMLElem = document.querySelector('.wishlist-count');
      this.swat.renderWishlistCount(countHTMLElem, function (cnt, elem) {
        window.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    }

    disconnectedCallback() {
      if (this.elements?.wishlistButton) {
        this.elements.wishlistButton.removeEventListener('click', this.handleClick);
        window.removeEventListener('variant:change', this.handleVariantChange);
      }
    }

    connectedCallback() {
      if (window._swat) {
        this.initialize(window._swat);
      }
    }
  }

  customElements.define('swymcs-wishlist-button', SwymWishlistButton);
}
